import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { HomeRedirectPage } from 'features/homePage'

export const Route = createFileRoute('/_authenticated/')({
  component: HomeRedirectPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Dashboard'),
      },
    ],
  }),
})
